// src/components/Header.js
import React from "react";

const Header = () => {
  return (
    <header>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <img
          src="SpandanLogo.png"
          alt="Spandan Blood Centre Logo"
          style={{
            height: "60px",
            width: "70px",
            background: "white",
            borderRadius: "20px",
            padding: "5px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
          }}
        />
        <p style={{
      fontSize: "8px",
      color: "white",
      marginTop: "1px",
      letterSpacing: "0.7px"
    }}>
      F.D.A Lic No.MH/105706
    </p>
  </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
    <p style={{
      margin: "0 0 1px 0",
      fontSize: "0.7rem",
      fontWeight: 400,
      color: "white",
      letterSpacing: "0.5px",
    }}>
      Sadguru Gajanan Maharaj Education Society, Paramedical Institute Sanchalit
    </p>
    <h1 style={{ margin: 3, fontSize: "1.4rem"}}>SPANDAN BLOOD CENTRE</h1>
  </div>
      </div>

      <nav style={{ display: "flex", alignItems: "center", gap: "1.8rem",fontWeight: "600",letterSpacing: "0.5px", }}>
        <a href="/">Home</a>
        <a href="facilities">Blood Bank Facilities</a>
        <a href="Camps">Camps</a>
        <a href="Team"> Our Team</a>
        <a href="Branches">Our Branches</a>
        <a href="about">About Us</a>
        <a href="contact">Contact Us</a>
        
      
        
        
      </nav>
    </header>
  );
};

export default Header;
